
require.register("lodash-compat/internal/isObjectLike.js", function(exports, require, module) {
  require = __makeRelativeRequire(require, {}, "lodash-compat");
  (function() {
    /**
 * Checks if `value` is object-like.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

module.exports = isObjectLike;
  })();
});